import React, { useState, useContext } from 'react';
import { Formik, Form, Field, useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import Error from '../Error/error';
import Eye from '../../images/icons/eye (1).svg';
import CloseEye from '../../images/icons/slashEye.svg';
import { createPassword as createPasswordApi } from '../../common/constants/api';
import { login } from '../../common/constants/api';
import { setToken as loginTokenSetter } from '../../common/utils/auth-utils';
import { PasswordInputField } from '../PasswordInputField/PasswordInputField';
import OKImage from '../../images/icons/verified.svg';
import {
  passwordValidation,
  validationMessage
} from '../PasswordValidation/PasswordValidation';

const createPassword = props => {
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    // setFieldValue,
    isValid,
    dirty,
    initialValues
  } = useFormikContext();
  const { values: wizardValues, setStatus, status, wizard } = useFormikWizard();
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  const [conFirmShowEyeIcon, SetConFirmShowEyeIcon] = useState(false);

  return (
    <div className=" relative py-2 pb-32 -mt-5 w-full max-w-sm mx-auto text-left">
      <div className=" ">
        <h1 className="text-lg font-roboto font-bold text-center my-10 text-black-100">
          SET YOUR PASSWORD
        </h1>
        <div className="mt-5  ">
          <PasswordInputField
            title="Enter Password"
            handleChange={handleChange}
            handleBlur={handleBlur}
            name="password"
            password={values.password}
            passwordValidation={passwordValidation}
            showEyeIcon={showEyeIcon}
            setShowEyeIcon={() => setShowEyeIcon(!showEyeIcon)}
          />
          <Error touched={touched.password} message={errors.password} />
        </div>
        {/* {initialValues} */}
        <div className="">
          {/* //confirmPassword */}
          <PasswordInputField
            title="Confirm Password"
            handleChange={handleChange}
            handleBlur={handleBlur}
            name="confirmPassword"
            password={values.confirmPassword}
            showEyeIcon={conFirmShowEyeIcon}
            setShowEyeIcon={() => SetConFirmShowEyeIcon(!conFirmShowEyeIcon)}
          />
          {values.password !== '' && !errors.password ? (
            <Error
              touched={touched.confirmPassword}
              message={errors.confirmPassword}
            />
          ) : null}
        </div>

        <button
          type="submit"
          className="submitButton w-full"
          disabled={
            values.password !== values.confirmPassword ||
            errors.password ||
            errors.confirmPassword ||
            values.password == '' ||
            values.confirmPassword == ''
          }
        >
          SAVE
        </button>
        <div className="text-red-200 mt-4 text-center">{status?.message}</div>
        <div>{validationMessage}</div>
      </div>
    </div>
  );
};
export default createPassword;
